import React from 'react';
import {DatePicker} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import moment from 'moment';

const LatestTelTermFilter = () => {
  const {query, setQuery} = useSearchParams();
  const {latestTelTerm} = query;
  const {RangePicker} = DatePicker;
  const format = 'YYYY-MM-DD';

  return (
    <RangePicker
      format={format}
      placeholder={['開始日', '終了日']}
      value={
        latestTelTerm?.from && latestTelTerm?.to
          ? [
              moment(latestTelTerm.from, format),
              moment(latestTelTerm.to, format),
            ]
          : null
      }
      onChange={(value) => {
        if (value) {
          setQuery({
            latestTelTerm: {
              from: value[0].format(format),
              to: value[1].format(format),
            },
          });
        } else {
          setQuery({
            latestTelTerm: null,
          });
        }
      }}
    />
  );
};

export default LatestTelTermFilter;
